@if (attribute?.displayName) {
  <div class="pl-3 text-color-secondary" style="font-size: var(--p-floatlabel-active-font-size)">
    {{ attribute?.displayName }}
  </div>
}
@if (multiPick) {
  <div class="month-container">
    <div class="month-grid">
      <p-selectButton
        class="month-button"
        styleClass="!text-center !flex !items-center !justify-center"
        [options]="firstRowMonths"
        optionLabel="name"
        optionValue="code"
        optionDisabled="disabled"
        [(ngModel)]="selectedMonths"
        [multiple]="true"
        (onChange)="onChange($event)"
      />
      <p-selectButton
        class="month-button"
        styleClass="!text-center !flex !items-center !justify-center"
        [options]="secondRowMonths"
        optionLabel="name"
        optionValue="code"
        optionDisabled="disabled"
        [(ngModel)]="selectedMonths"
        [multiple]="true"
        (onChange)="onChange($event)"
      />
    </div>
    @if (groupButtons) {
      <div class="bottom-buttons">
        <p-button variant="outlined" class="action-button" styleClass="!py-1 !text-center !flex !items-center !justify-center" (click)="selectAllGroupE($event)"
          >All</p-button
        >
        <p-button
          variant="outlined"
          class="action-button"
          styleClass="!py-1 !text-center !flex !items-center !justify-center"
          (click)="selectQuarterlyGroupE($event)"
          >Quarterly</p-button
        >
        <p-button variant="outlined" class="action-button" styleClass="!py-1 !text-center !flex !items-center !justify-center" (click)="clearGroupE($event)">Clear</p-button>
      </div>
    }
  </div>
} @else {
  <p-selectButton
    [options]="monthsOfYear"
    optionLabel="name"
    optionValue="code"
    optionDisabled="disabled"
    [(ngModel)]="selectedMonth"
    [multiple]="false"
    (onChange)="onChange($event)"
  />
}
